/**
 * Coup de pouce, Attendu 1217 « puissance comme multiplication itérée :
 * 3 × 3 × 3 × 3 = 3⁴ » (3e, Puissances, l. 743). Seconde passe 3e
 * (2026-09-13). UNE page STATIQUE partagée par les trois clés.
 *
 * L'image que l'élève a déjà : la définition de 4e (l. 682, « définir les
 * puissances d'exposant positif d'un nombre a ») écrite comme il l'a vue
 * au tableau : le facteur répété, compté. Quatre 3 en bleu, comptés 1, 2,
 * 3, 4 au-dessus ; l'exposant 4 en orange ; « le petit 4 compte le nombre de
 * fois qu'il y a le chiffre 3 » (formulation prof 2026-09-18).
 * La vérification vise l'erreur principale (3 × 4 = 12 lu à la place de
 * 3⁴ = 81) ; le sens inverse (3⁴ → quatre facteurs 3) est sur la même
 * figure.
 *
 * SACRIFIÉ : (3 ; 4), dans les deux sens, sur tout ce qui s'affiche
 * (gen1217.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;

const X = [92, 136, 180, 224];
const FACTEURS = X.map((x, k) => `<text x="${x}" y="80" font-size="24" font-weight="bold" text-anchor="middle" fill="${BLEU}">3</text>
  <text x="${x}" y="46" font-size="11" text-anchor="middle" fill="${ORANGE}">${k + 1}</text>
  <path d="M ${x - 12} 56 Q ${x} 44 ${x + 12} 56" fill="none" stroke="${ORANGE}" stroke-width="1.2"/>`).join('\n  ');
const CROIX = [114, 158, 202].map((x) => `<text x="${x}" y="80" font-size="20" text-anchor="middle" fill="${ENCRE}">×</text>`).join('\n  ');

const SVG = svg(
    '3 fois 3 fois 3 fois 3 : le nombre 3 est écrit quatre fois, on compte 1, 2, 3, 4 au-dessus. Cela s’écrit 3 exposant 4, le petit 4 en orange. Le petit 4 compte le nombre de fois qu’il y a le chiffre 3 : quatre facteurs 3. 3 exposant 4 égale 81 ; ce n’est pas 3 fois 4.',
    `<!-- 1. le produit, chaque facteur compté -->
  ${FACTEURS}
  ${CROIX}
  <text x="250" y="80" font-size="20" text-anchor="middle" fill="${ENCRE}">=</text>
  <text x="290" y="80" font-size="26" font-weight="bold" text-anchor="middle" fill="${BLEU}">3<tspan font-size="15" fill="${ORANGE}" dy="-12">4</tspan></text>

  <!-- 2. le geste -->
  ${ligne(120, `Le <tspan fill="${ORANGE}" font-weight="bold">petit 4</tspan> compte le nombre de fois`, 13)}
  ${ligne(138, `qu’il y a le chiffre <tspan fill="${BLEU}" font-weight="bold">3</tspan> : quatre facteurs 3.`, 13)}
  ${ligne(162, '3⁴ se lit « 3 exposant 4 » ou « 3 puissance 4 ».', 12)}
  ${ligne(190, '3⁴ = 3 × 3 × 3 × 3 = 81.  Ce n’est pas 3 × 4.', 12, GRIS)}`,
    208,
);

const AIDE = { pages: [{ titre: 'Le petit 4 compte les 3', svg: SVG }] };

const CP_1217 = {
    flash_texte_trou_saisie: AIDE,
    ecriture_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1217;
